<template>
	<h2
		:class="[
			'text-slate-900 leading-tight ',
			{
				'font-bold': weight === 'bold',
				'font-medium': weight === 'medium',
				'font-normal': weight === 'normal',
				'text-2xl': size === 'normal',
				'text-xl': size === 'small'
			}
		]"
	>
		<slot />
	</h2>
</template>

<script setup>
const props = defineProps({
	tag: {
		type: String,
		default: "h2"
	},
	weight: {
		type: String,
		default: "bold"
	},
	size: {
		type: String,
		default: "normal"
	}
});
</script>
